import { twMerge } from 'tailwind-merge';

type PageNumberProps = {
  value: number | string;
  isActive?: boolean;
  onClick?: () => void;
  variant?: 'default' | 'analytics' | 'wheelOfFortune' | 'taskBased';
};

export const PageNumber = ({ isActive, value, onClick, variant = 'default' }: PageNumberProps) => {
  const variantStyles = {
    default: {
      active: 'tw-bg-[#4987FF] tw-text-white',
      inactive: 'tw-bg-transparent tw-text-white',
      text: 'tw-text-base tw-leading-6 tw-text-white',
      button: 'tw-h-[30px] tw-w-[30px] lg:tw-h-[35px] lg:tw-w-[35px]',
    },
    analytics: {
      active: 'tw-bg-[#1F1F1F] tw-text-white',
      inactive: 'tw-bg-transparent tw-text-white',
      text: 'tw-font-bold tw-leading-6 tw-text-white tw-text-[12px]',
      button: 'tw-w-[22px] tw-h-[22px]',
    },
    wheelOfFortune: {
      active: 'tw-bg-[#1F408C] tw-text-white',
      inactive: 'tw-bg-transparent tw-text-white',
      text: 'tw-text-[12px] tw-leading-none tw-text-white tw-font-jost tw-font-bold',
      button: 'tw-h-[22px] tw-w-[22px]',
    },
    taskBased: {
      active: 'tw-bg-[#4987FF] tw-text-white',
      inactive: 'tw-bg-transparent tw-text-white',
      text: 'tw-text-base tw-leading-6 tw-text-white',
      button: 'tw-h-[30px] tw-w-[30px] lg:tw-h-[35px] lg:tw-w-[35px]',
    },
  } as const;

  const isSeparator = value === '...';

  return (
    <button
      type="button"
      onClick={isSeparator ? undefined : onClick}
      disabled={isSeparator}
      className={twMerge(
        'tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border-none tw-p-0',
        variantStyles[variant].button,
        isSeparator ? 'tw-cursor-default' : 'tw-cursor-pointer',
        isActive ? variantStyles[variant].active : variantStyles[variant].inactive
      )}
    >
      <span className={variantStyles[variant].text}>{value}</span>
    </button>
  );
};
